import React from "react"
import styled from "styled-components"

import { useTranslations } from "next-intl"
import Spacer from "~/components/Spacer"
import PaymentLogo from "./logos/PaymentLogo"
import SearchTicketLogo from "./logos/SearchTicketLogo"
import WinItLogo from "./logos/WinitLogo"
import DotDotDotLogo from "./logos/DotDotDotLogo"

const WhatWeOfferContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: ${props => (props.isMobile ? "column" : "row")};
  flex-wrap: wrap;
  height: ${props => (props.isMobile ? "55.25rem" : "")};
`
const WhatWeOfferItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  flex-shrink: 0;
  ${"" /* min-width: 175px; */}
`
const DotDotDotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${props => (props.isMobile ? "rotate(90deg)" : "")};
  flex: 1;
`
const ImageLabelContainer = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: #262626;
  font-size: 1.375rem;
  text-align: center;
`
const ImageDescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props => props.theme.colors.text.subContent};
  font-size: 1rem;
  text-align: center;
  flex-shrink: 0;
`

const WhatWeOffer = ({ isMobile }) => {
  const translate = useTranslations('parking.heroTexts.offerings')
  
  return (
    <WhatWeOfferContainer isMobile={isMobile}>
      <WhatWeOfferItems>
        <SearchTicketLogo />
        <Spacer mobile={46} desktop={46} />
        <ImageLabelContainer>{translate('ticketSearch.title')}</ImageLabelContainer>
        <Spacer mobile={13} desktop={13} />
        <ImageDescriptionContainer>
          {translate('ticketSearch.description')}
        </ImageDescriptionContainer>
      </WhatWeOfferItems>
      <DotDotDotContainer isMobile={isMobile}>
        <DotDotDotLogo />
      </DotDotDotContainer>
      <WhatWeOfferItems>
        <PaymentLogo />
        <Spacer mobile={38} desktop={38} />
        <ImageLabelContainer>{translate('payment.title')}</ImageLabelContainer>
        <Spacer mobile={13} desktop={13} />
        <ImageDescriptionContainer>
          {translate('payment.description')}
        </ImageDescriptionContainer>
      </WhatWeOfferItems>
      <DotDotDotContainer isMobile={isMobile}>
        <DotDotDotLogo />
      </DotDotDotContainer>
      <WhatWeOfferItems>
        <WinItLogo />
        <Spacer mobile={54} desktop={54} />
        <ImageLabelContainer>{translate('winIt.title')}</ImageLabelContainer>
        <Spacer mobile={13} desktop={13} />
        <ImageDescriptionContainer>
          {translate('winIt.description')}
        </ImageDescriptionContainer>
      </WhatWeOfferItems>
    </WhatWeOfferContainer>
  )
}

export default WhatWeOffer
